// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>

import GlobalStyles from '../../../config/styles';

const styles = theme => ({
  container: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'column',
  },
  contentContainer: {
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  statusIcon: {
    marginTop: 30,
    width: 80,
    height: 80,
  },
  text: {
    width: '65%',
    marginTop: 35,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE,
    color: GlobalStyles.color.COLOR_GREY,
    textAlign: 'center',
    [theme.breakpoints.down(520)]: {
      width: '75%',
      fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    },
  },
  button: {
    marginTop: 30,
    height: 50,
    width: 300,
    [theme.breakpoints.down(520)]: {
      width: 200,
    },
  },
  helperText: {
    width: 290,
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
  },
});

export default styles;
